import httpUtil from "@/utils/httpUtil";

export const add = params => httpUtil.post("/api/boomClass", params);
export const del = params => httpUtil.delete(`/api/boomClass/delete/${params}`);
export const query = params => httpUtil.get("/api/boomClass", params);
export const queryList = params => httpUtil.get("/api/boomExcle", params);
export const getPurchase = params => httpUtil.post("/aps/getPurchase", params);
export const getDelivery = params => httpUtil.post("/aps/getDelivery", params);

export const save = params => httpUtil.post("/api/boomClass/save", params);

export const list = params => httpUtil.get("/api/boomClass/list", params);

// 新增出库/采购清单
export const addBoomApi = params => httpUtil.post("/api/boomExcle/save", params);
// 完成采购清单
export const completePurchase = params => httpUtil.get("/api/boomExcle/completePurchase", params);
export const syncDealer = params => httpUtil.get("/api/boomExcle/syncDealer", params);
export const delOrder = params => httpUtil.delete(`/api/boomExcle/delete/${params}`);

// 查询经销商
export const getDealerListApi = params => httpUtil.get("/api/boomExcle/listByExcleId", params);
// 绑定经销商
export const bindDealerApi = params => httpUtil.get("/api/boomExcle/bindDealer", params);
export const listByType = params => httpUtil.get("/api/boomExcle/listByType", params);
export const taskProcess = params => httpUtil.get("/api/boomExcle/taskProcess", params);
export const outStock = params => httpUtil.post("/api/boomExcle/outStock", params);

// 获取订单详情
export const getExcleParam = params => httpUtil.get("/api/boomExcle/getOrderDetail", params);
export const getContainerCode = params => httpUtil.post("/api/boomExcle/getContainerCode", params);
export const queryProduct = params => httpUtil.get("/api/boomExcle/queryProduct", params);
// 更新部分采购状态
export const updatePurchaseStatus = params => httpUtil.get("/api/boomExcle/updatePurchaseStatus", { json: JSON.stringify(params) });
